<template>
  <div class="backgroud-white cs-paymentDetails">
    <table>
      <tr class="cs-paymentDetails-titleRow">
        <td :span="1"></td>
        <td :span="1" v-for="(item, index) in details" :key="index">
          <span>{{item.PaymentTypeDescription}}</span>
          <img class="cs-paymentDetails-paymentIcon" :src="getImgSrc(item.PaymentTypeName)">
        </td>
        <td></td>
      </tr>
      <tr>
        <td><span>待核对</span></td>
        <td v-for="(item, index) in details" :key="index">{{item.UncheckedAmount | toCurrency(currency)}}</td>
        <td class="cs-paymentDetails-total"><span>待核对总数：</span>{{getUncheckedAmountSum() | toCurrency(currency)}}</td>
      </tr>
      <tr>
        <td><span>已核对</span></td>
        <td v-for="(item, index) in details" :key="index">{{(item.TotalAmount - item.UncheckedAmount) | toCurrency(currency)}}</td>
        <td class="cs-paymentDetails-total"><span>已核对总数：</span>{{getCheckedAmountSum() | toCurrency(currency)}}</td>
      </tr>
      <tr>
        <td><span>已付款</span></td>
        <td v-for="(item, index) in details" :key="index">{{item.TotalAmount | toCurrency(currency)}}</td>
        <td class="cs-paymentDetails-total"><span>已付款总数：</span>{{getTotalAmountSum() | toCurrency(currency)}}</td>
      </tr>
      <tr>
        <td><span>税费</span></td>
        <td v-for="(item, index) in details" :key="index">{{item.TaxAmount | toCurrency(currency)}}</td>
        <td class="cs-paymentDetails-total"><span>税费总数：</span>{{getTaxAmountSum() | toCurrency(currency)}}</td>
      </tr>
      <tr>
        <td><span>手续费</span></td>
        <td v-for="(item, index) in details" :key="index">{{item.ServiceChargeAmount | toCurrency(currency)}}</td>
        <td class="cs-paymentDetails-total"><span>手续费总数：</span>{{getTotalServiceChargeSum() | toCurrency(currency)}}</td>
      </tr>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.cs-paymentDetails {
  table {
    width: 100%;
    border: 1px solid #ced3d9;
    margin: 10px 0;
    td{
      border: 1px solid #ced3d9;
      width:8%;
      text-align: center;
      
      padding: 2px 5px;

      &:first-of-type{
        width: 6%
      }

      &:last-of-type{
        width: 12%
      }

      span{
        margin: 0;
      }
    }

    .cs-paymentDetails-total{
      span{
        display: block;
        width: 100%;
      }
    }

    .cs-paymentDetails-titleRow{
      font-size: 12px;
    }
    
    .cs-paymentDetails-paymentIcon {
      display: inline-block;
      width: 20px;
      margin-left: 3px;
    }
  }
}
</style>

<script>
import { getPaymentImgList } from "../../config/mUtils.js";

export default {
  props: {
    currency: {
      type: [Number],
      default: 2,
    },
    details: Array
  },
  data() {
    return {
      paymentImgList: []
    };
  },
  components: {},
  created() {
    this.paymentImgList = getPaymentImgList();
  },
  methods: {
    getImgSrc(name) {
      return this.paymentImgList[name];
    },
    getTotalServiceChargeSum(){
      let total = 0;
      this.details.forEach(element => {
        total += element.ServiceChargeAmount;
      });
      return total;
    },
    getTaxAmountSum(){
      let total = 0;
      this.details.forEach(element => {
        total += element.TaxAmount;
      });
      return total;
    },
    getUncheckedAmountSum() {
      let total = 0;
      this.details.forEach(element => {
        total += element.UncheckedAmount;
      });
      return total;
    },
    getCheckedAmountSum(){
      let total = 0;
      this.details.forEach(element => {
        total += element.TotalAmount - element.UncheckedAmount;
      });
      return total;
    },
    getTotalAmountSum() {
      let total = 0;
      this.details.forEach(element => {
        total += element.TotalAmount;
      });
      return total;
    }
  },
  watch: {
    data: function() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/finance/paymentDetails.vue